module.exports = __webpack_public_path__ + "static/media/defaultAdmin.90bb5bae.svg";